
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/dialog-actions",
      function () {
        return require("private-next-pages/joy-ui/api/dialog-actions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/dialog-actions"])
      });
    }
  